import { render, staticRenderFns } from "./CloseSlash.vue?vue&type=template&id=40cb8603"
import script from "./CloseSlash.vue?vue&type=script&lang=js"
export * from "./CloseSlash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports